module.exports = "<div class=\"panel popin\">\n  <div class=\"panel-heading\">\n    <div class=\"title\">{{titre}}</div>\n  </div>\n  <div class=\"panel-body\">\n    <div class=\"\" style=\"margin:15px 0 15px 0\">{{messageError}}</div>\n    <button class=\"btn\" style=\"float: right\" (click)=\"masquer()\">OK</button>\n  </div>\n</div>\n<div class=\"layer\"></div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/popin/popin.component.html
// module id = ./src/app/popin/popin.component.html
// module chunks = main